import { PiPiggyBankFill } from "react-icons/pi";
import { RiFileList3Fill } from "react-icons/ri";
import { FaUserLarge } from "react-icons/fa6";
import { BsFillCreditCard2BackFill } from "react-icons/bs";

import { ProtectedRoutes } from "../../../types/Routes";
import SettingsNavBarItem from "./SettingsNavBarItem";

const SettingsNavBar = () => {
  return (
    <nav className="flex flex-col justify-between w-full h-fit ">
      <div className="flex gap-[46px] max-md:gap-[20px] overflow-auto justify-around">
        <SettingsNavBarItem
          name="Profile"
          route={ProtectedRoutes.PROFILE}
          Icon={FaUserLarge}
        />
        {/* <SettingsNavBarItem name="Messages" route="/settings/messages" /> */}
        {/* <SettingsNavBarItem TODO: for later
          name="Notifications"
          route="/settings/notifications"
        /> */}
        <SettingsNavBarItem
          name="Activation Credits"
          route={ProtectedRoutes.ACTIVATION_CREDITS}
          Icon={BsFillCreditCard2BackFill}
        />
        <SettingsNavBarItem
          name="Accounts/beneficiary"
          route={ProtectedRoutes.ACCOUNT}
          Icon={PiPiggyBankFill}
        />
        <SettingsNavBarItem
          name="Plan & Billing"
          route={ProtectedRoutes.BILLING}
          Icon={RiFileList3Fill}
        />
      </div>
      <div className="w-full h-[1px] bg-[#EAECF0]"></div>
    </nav>
  );
};

export default SettingsNavBar;
